import { PrescriberPublicProfile, User } from '../../../../../../apis/users';
import { PublicProfileFormData } from './types';

export function publicProfileFormData(user: User): PublicProfileFormData {
  return {
    title: user.public_profile?.title || '',
    bio: user.public_profile?.bio || '',
    image_url: user.public_profile?.image_url || '',
  };
}

// Blank fields are left out, so the clinic pages see a missing picture or bio rather than ''. A profile with
// nothing filled in is null, which clears a saved one.
export function toPublicProfilePayload(profile?: PublicProfileFormData): PrescriberPublicProfile | null {
  const filled = Object.entries(profile || {}).reduce((kept, [key, value]) => {
    const trimmed = typeof value === 'string' ? value.trim() : value;
    return trimmed ? { ...kept, [key]: trimmed } : kept;
  }, {} as PrescriberPublicProfile);

  return Object.keys(filled).length > 0 ? filled : null;
}
